import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import './index.css';
import './components/ui/ui.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ConfirmProvider } from './context/ConfirmContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (process.env.REACT_APP_APP_MODE === 'firewatch') {
  // Public FireWatch surface — no auth/toast/confirm providers.
  void import('./firewatch/FirewatchApp').then(({ default: FirewatchApp }) => {
    root.render(
      <React.StrictMode>
        <FirewatchApp />
      </React.StrictMode>
    );
  });
} else {
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <ToastProvider>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </ToastProvider>
      </AuthProvider>
    </React.StrictMode>
  );
}
